import React, { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

// Looping arcade groove — per-style lobby / join-room background music.
const TRACKS = {
  hip_retro:
    "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/j8fvtbt6_Looping%20Cloud%20Quest%20%2860s%E2%80%9370s%20Arcade%20Groove%29.mp3",
  rock_roll:
    "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/mmg30d16_Looping%20Cloud%20Quest%20%28Rock%20Loop%20Mix%29.mp3",
  puppy_love:
    "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/1tm6d66d_Looping%20Cloud%20Quest%20%28R%26B%20Hip%20Hop%20Loop%29.mp3",
};

const PREF_KEY = "hm_lobby_music_on";

// Loops infinitely, muted by default (browser autoplay rules). A small floating
// speaker toggle lets the player turn sound on before they tap "Ready".
export const LobbyMusic = ({ styleId }) => {
  const track = TRACKS[styleId];
  const audioRef = useRef(null);
  const [soundOn, setSoundOn] = useState(() => {
    try { return localStorage.getItem(PREF_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (!track) return;
    const a = audioRef.current;
    if (!a) return;
    a.volume = 0.35;
    a.muted = true;
    a.load?.();
    a.play?.()?.catch(() => {});
    // If the player already enabled sound earlier this session, try to unmute.
    if (soundOn) {
      a.muted = false;
      a.play?.()?.catch(() => { a.muted = true; });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [track]);

  if (!track) return null;

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    const next = !soundOn;
    setSoundOn(next);
    try { localStorage.setItem(PREF_KEY, next ? "1" : "0"); } catch {}
    a.muted = !next;
    if (next) {
      a.volume = 0.35;
      a.play?.()?.catch(() => {});
    }
  };

  return (
    <>
      <audio
        ref={audioRef}
        src={track}
        loop
        autoPlay
        muted
        playsInline
        preload="auto"
        data-testid="lobby-music-audio"
      />
      <button
        type="button"
        data-testid="lobby-music-toggle"
        onClick={toggle}
        aria-label={soundOn ? "Zet muziek uit" : "Zet geluid aan"}
        title={soundOn ? "Muziek uit" : "Geluid aan"}
        className="fixed z-50 flex items-center justify-center rounded-full border-2 text-white transition-all hover:scale-105 active:scale-95"
        style={{
          top: 14,
          right: 14,
          width: 48,
          height: 48,
          borderColor: "rgba(255,255,255,0.75)",
          backgroundColor: soundOn ? "rgba(5,150,105,0.9)" : "rgba(0,0,0,0.5)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          boxShadow: "0 6px 16px rgba(0,0,0,0.45)",
        }}
      >
        {soundOn ? <Volume2 className="w-6 h-6" strokeWidth={2.4} /> : <VolumeX className="w-6 h-6" strokeWidth={2.4} />}
        {!soundOn && (
          <span
            className="absolute -bottom-6 whitespace-nowrap font-bebas uppercase tracking-widest text-white"
            style={{ fontSize: 11, textShadow: "0 2px 6px rgba(0,0,0,0.7)" }}
          >
            Sound on
          </span>
        )}
      </button>
    </>
  );
};

export default LobbyMusic;
